angular
  .module("meanApp")
  .controller("online-simulator-controller", function($scope, $stateParams) {
    "use strict";

    const reactContainerNode = document.getElementById("react-wrapper-sim");
    ReactDOM.unmountComponentAtNode(reactContainerNode);
    ReactDOM.render(
      React.createElement(OnlineSimulator.default, {
        clientUID: $stateParams.clientId
      }),
      reactContainerNode
    );

    $scope.$on("$destroy", () => {
      ReactDOM.unmountComponentAtNode(reactContainerNode);
    });
  });
